package com.rosario.juridico.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class MediacionGasto(
    val nroMediacion: String = "",
    val fechaFormulario: String = "",
    val mediadorNombre: String = "",
    val mediadorMatricula: String = "",
    val mediadorRegistro: String = "",
    val mediadorJurisdiccion: String = "",
    val mediadorEmail: String = "",
    val mediadorWhatsapp: String = "",
    val patrocinanteNombre: String = "",
    val patrocinanteTelefono: String = "",
    val patrocinanteEmail: String = "",
    val requerente: String = "",
    val requerido: String = "",
    val objeto: String = "",
    val responsablePago: String = "",
    val oficinaLugar: String = "",
    val oficinaCalle: String = "",
    val oficinaCiudad: String = "",
    val oficinaTelefono: String = "",
    val oficinaEmail: String = "",
    val pagoAlias: String = "",
    val pagoDni: String = "",
    val pagoBanco: String = "",
    val pagoCajaAhorro: String = "",
    val pagoCbu: String = "",
    val pagoCuitCuil: String = "",
    
    // Datos calculados
    val honorariosJus: Double = 0.0,
    val honorariosPesos: Double = 0.0,
    val aportesJus: Double = 0.0,
    val aportesPesos: Double = 0.0,
    val gastosAdministrativosJus: Double = 0.0,
    val gastosAdministrativosPesos: Double = 0.0,
    val valorJus: Double = 0.0,
    val tipoMediacion: String = "",
    
    val cartasDocumento: List<CartaDocumentoItem> = emptyList()
) {
    val totalPesos: Double get() = honorariosPesos + aportesPesos + gastosAdministrativosPesos + cartasDocumento.sumOf { it.monto }
}

@Serializable
data class CartaDocumentoItem(
    val id: String, // UUID o timestamp para identificar en UI
    val destinatarioNombre: String = "",
    val destinatarioCalle: String = "",
    val destinatarioCiudad: String = "",
    val monto: Double = 0.0
)
